import { VariantProps, cva } from 'class-variance-authority';

export const richTextEditorActionStyles = cva(
  'transition-colors ease-out duration-200 fill-primaryMain outline-none bg-grayscale0 rounded-4 p-4',
  {
    variants: {
      state: {
        active:
          'bg-primary100 data-[hovered="true"]:bg-primary200 data-[focused="true"]:bg-primary200 data-[pressed="true"]:bg-grayscale0',
        inactive:
          'data-[hovered="true"]:bg-primary50 data-[focused="true"]:bg-primary50 data-[pressed="true"]:bg-primary100',
      },
      color: {
        blue: 'fill-info300',
        grey: 'fill-grayscale500',
      },
    },
    defaultVariants: {
      state: 'inactive',
      color: 'grey',
    },
  },
);

export type RichTextEditorActionStyles = VariantProps<
  typeof richTextEditorActionStyles
>;
